import { Component, ElementRef, ViewChild } from "@angular/core";
import { PreviewItemFilterOptionComponent } from "../preview-item-filter-option.component";

@Component({
    imports: [],
    templateUrl: "./preview-item-filter-option-sort.component.html"
})
export class PreviewItemFilterOptionSortComponent extends PreviewItemFilterOptionComponent {
    @ViewChild("selfSort") private selfSortRef!: ElementRef<HTMLSelectElement>;

    public constructor() {
        super();
    }

    public override loadStoredOptionValue(value: string): void {
        super.loadStoredOptionValue(value);
        this.trySetSelectedOption(this.selfSortRef.nativeElement, value);
    }
}